export const OPEN_MODAL_EVENT = 'react:open-modal';

export interface ModalEventDetail {
    name: string;
    props: Record<string, unknown>;
}

export const openModal = (name: string, props: Record<string, unknown> = {}): void => {
    document.dispatchEvent(
        new CustomEvent<ModalEventDetail>(OPEN_MODAL_EVENT, { detail: { name, props } })
    );
};
